import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {TaskStatusIds} from './../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskDetailsReducer(
	state = initialState.taskDescriptions,
	action
) {
	switch (action.type) {
		case types.GET_KNOWLEDGE_DESCRIPTIONS: {
			let taskDetails = action.response;
            let newDescription = {
                id: taskDetails.taskId,
                taskTypeId : taskDetails.taskTypeId,
                description: taskDetails.description,
                knowledgeTaskDescription: taskDetails.knowledgeTaskDescription
            }
		
			return [...state, newDescription];
        };
        default:
			return state;
	}
}